import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { firstValueFrom, take } from 'rxjs';

import { selectSessionCancellationReason } from '../../features/session/store/selectors/session.selectors';

/**
 * Guards the `/session-canceled` route. Access is only permitted when the
 * session has been flagged as canceled in the store (set by SignalR-driven
 * effects). Direct URL access by typing the route is redirected to the
 * landing page.
 */
export const sessionCanceledGuard: CanActivateFn = async () => {
  const store = inject(Store);
  const router = inject(Router);

  const reason = await firstValueFrom(
    store.select(selectSessionCancellationReason).pipe(take(1)),
  );

  if (reason !== null) {
    return true;
  }

  return router.createUrlTree(['/']);
};
